import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter,Routes,Route} from "react-router-dom";
import "./components/assets/css/style.css";
import "./components/assets/css/responsive.css"
import reportWebVitals from './reportWebVitals';
import "./components/assets/css/font-awesome.min.css";


import Login from './components/login';
import Categories from './components/categories';
import Home from './components/home';
import Sitemaintanence from './components/home/Sitemaintanence';
import Product from './components/products';
import Checkout from './components/checkout';
import Checkoutfree from './components/checkout/Checkoutfree';
import Checkoutpay from './components/checkout/checkout';
import Thankyou from './components/checkout/thankyou';
import Account from './components/account';
import ForgotPassword from './components/account/Forgotpassword';
import ResetPassword from './components/account/ResetPassword';

import Myaccount from './components/account/Myaccount';
import Terms from './components/common/terms';

import Test from './components/test';

ReactDOM.render(
  <React.StrictMode>
     <BrowserRouter>
     <Routes>

      <Route path="home" element={<Home />} />
      <Route path="sitemaintanance" element={<Sitemaintanence />} />
      <Route path="offerinfo" element={<Checkoutfree />} />
      <Route path="categories" element={<Categories />} />
      <Route path="terms" element={<Terms />} />
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="products" element={<Product />} />
      <Route exact path="checkout/:name" element={<Checkout />} />
      <Route path="checkoutpay" element={<Checkoutpay />} />
      <Route path="thankyou" element={<Thankyou />} />
      <Route path="account" element={<Account />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route exact path="/resetpassword/:token/:userid" element={<ResetPassword />} />
      <Route path="myaccount" element={<Myaccount />} /> 
      {/* <Route path="myaccount" element={<Myaccount />} /> */}
      <Route path="*" element={<Home />} />
      <Route path="/test" element={<Test />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();